var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main-section', [!_vm.isInitiated ? [_c('v-fade-transition', [_c('v-overlay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading,
      expression: "loading"
    }],
    attrs: {
      "color": "white"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "size": "100",
      "width": "5",
      "color": "primary",
      "indeterminate": ""
    }
  })], 1)], 1)] : !_vm.isAccessible ? [_c('view-code', _vm._b({}, 'view-code', {
    lecture: _vm.lecture
  }, false))] : [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "9"
    }
  }, [_c('view-info', [_c('view-video')], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "3"
    }
  }, [_c('view-chat')], 1), _vm.isUserCompany ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('view-meta')], 1) : _vm._e()], 1)]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }